export default {
  buttons: {
    add: 'Aggiungi',
  },
  AddOn: {
    label: 'Componente aggiuntivo',
    title: 'Ottieni la tua app mobile',
    subscribed: 'Abbonato',
    cta: 'Ottieni la tua app mobile',
    price_per_month: '{{price}} / mese',
    tax_included: 'tasse incluse',
    apple_developer_note:
      "Richiede un account Apple Developer (99$/anno, pagato ad Apple) intestato all'entità legale del ristorante.",
    features: {
      stores: 'Disponibile su App Store e Google Play',
      push: 'Notifiche push ai tuoi clienti',
      loyalty: 'Punti fedeltà e premi',
      commission: 'Ordini diretti con commissione dello 0%',
    },
  },
};
